/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentIcnModel } from './paymentIcnModel';

export interface VisitInsuranceBillingInfoModel {
  id?: string;
  patientId?: string;
  primaryInsuranceId?: string;
  secondaryInsuranceId?: string | null;
  tertiaryInsuranceId?: string | null;
  primaryCarrierDisplay?: string | null;
  primaryClaimType?: string | null;
  secondaryCarrierDisplay?: string | null;
  secondaryClaimType?: string | null;
  tertiaryCarrierDisplay?: string | null;
  tertiaryClaimType?: string | null;
  paymentIcns?: Array<PaymentIcnModel> | null;
}
